import { createFileRoute, redirect } from "@tanstack/react-router";

// Vecchio URL del sito precedente: reindirizzamento permanente alla sezione servizi.
export const Route = createFileRoute("/servizi")({
  beforeLoad: () => {
    throw redirect({ to: "/", hash: "servizi", statusCode: 301 });
  },
});
